import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import { Form, Typography, Table, Button, Input, Icon, Modal } from 'antd';
import AddCircleIcon from '@material-ui/icons/AddCircle';
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import { green } from '@material-ui/core/colors';
import 'antd/dist/antd.css';
import Highlighter from 'react-highlight-words';

const { Title } = Typography;

@inject("chatIntentStore")
@observer
class ChatIntentList extends Component {
    constructor(props) {
        super(props);
        this.state = {
            searchText: '',
            searchedColumn: ''
        }
    }

    componentDidMount() {
    }

    createClicked = () => this.props.chatIntentStore.initCreate()
    updateClicked = chatIntentID => this.props.chatIntentStore.initUpdate(chatIntentID)
    removeClicked = chatIntentID => this.props.chatIntentStore.deleteChatIntent(chatIntentID)

    deleteClicked = chatIntentID => {
        Modal.confirm({
            title: 'Remove Chat Intent',
            content: 'Are you sure to remove chat intent?',
            okText: 'Remove',
            cancelText: 'Cancel',
            onOk: () => this.removeClicked(chatIntentID)
        });
    }

    getColumns = () => {
        return [
            {
                title: 'Intent Name',
                dataIndex: 'intentName',
                key: 'intentName',
                width: '15%',
                ...this.getColumnSearchProps('intentName')
            },
            {
                title: 'Answer',
                dataIndex: 'answer',
                key: 'answer',
                width: '30%',
                ...this.getColumnSearchProps('answer'),
                render: answer => {
                    if (answer === '' || answer === null) {
                        return '-'
                    }

                    return answer;
                }
            },
            {
                title: 'Confirmation Info',
                dataIndex: 'intentRedirectName',
                key: 'intentRedirectName',
                width: '20%',
                ...this.getColumnSearchProps('intentRedirectName'),
                render: intentRedirectName => {
                    if (intentRedirectName === '' || intentRedirectName === null) {
                        return '-'
                    }

                    return intentRedirectName;
                }
            },
            {
                title: 'Intent Redirect URL',
                dataIndex: 'intentRedirectUrl',
                key: 'intentRedirectUrl',
                width: '20%',
                ...this.getColumnSearchProps('intentRedirectUrl'),
                render: intentRedirectUrl => {
                    if (intentRedirectUrl === '' || intentRedirectUrl === null) {
                        return '-'
                    }

                    return intentRedirectUrl;
                }
            },
            {
                title: 'Action',
                dataIndex: 'chatIntentID',
                key: 'action',
                width: '10%',
                render: chatIntentID => (
                    <span>
                        <Button onClick={() => this.updateClicked(chatIntentID)} type="primary" style={{ border: "none", background: "none", boxShadow: "none", margin: 1, padding: 0}}>
                            <EditIcon style={{ color: "#1890ff", fontSize: 24 }} />
                        </Button>
                        <Button onClick={() => this.deleteClicked(chatIntentID)} type="primary" style={{ border: "none", background: "none", boxShadow: "none", margin: 1, padding: 0 }}>
                            <DeleteIcon style={{ color: "#DC004E", fontSize: 24 }} />
                        </Button>
                    </span>
                ),
            },
        ]
    }

    getColumnSearchProps = dataIndex => ({
        filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
            <div style={{ padding: 8 }}>
                <Input
                    ref={node => {
                        this.searchInput = node
                    }}
                    placeholder={`Search ${dataIndex}`}
                    value={selectedKeys[0]}
                    onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
                    onPressEnter={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
                    style={{ width: 188, marginBottom: 8, display: 'block' }}
                />
                <Button
                    type="primary"
                    onClick={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
                    icon="search"
                    size="small"
                    style={{ width: 90, marginRight: 8 }}
                >
                    Search
            </Button>
                <Button onClick={() => this.handleReset(clearFilters)} size="small" style={{ width: 90 }}>
                    Reset
            </Button>
            </div>
        ),
        filterIcon: filtered => (
            <Icon type="search" style={{ color: filtered ? '#1890ff' : undefined }} />
        ),
        onFilter: (value, record) =>
            record[dataIndex]
                .toString()
                .toLowerCase()
                .includes(value.toLowerCase()),
        onFilterDropdownVisibleChange: visible => {
            if (visible) {
                setTimeout(() => this.searchInput.select())
            }
        },
        render: text =>
            this.state.searchedColumn === dataIndex ? (
                <Highlighter
                    highlightStyle={{ padding: 0 }}
                    searchWords={[this.state.searchText]}
                    autoEscape
                    textToHighlight={text.toString()}
                />
            ) : (
                    text
                ),
    });

    handleSearch = (selectedKeys, confirm, dataIndex) => {
        confirm()
        this.setState({
            searchText: selectedKeys[0],
            searchedColumn: dataIndex,
        });
    };

    handleReset = clearFilters => {
        clearFilters()
        this.setState({ searchText: '' })
    }

    render() {
        const {
            chatIntents
        } = this.props.chatIntentStore;

        return (
            <React.Fragment>
                <Form layout="horizontal">
                    <div style={{ marginBottom: 20 }}>
                        <Title level={3} style={{ width: "80%", position: "relative", float: "left" }}>Chat Intent List</Title>
                        <div style={{ textAlign: "right" }}>
                            <button type="button" style={{ border: "none", background: "none", cursor: "pointer" }} onClick={this.createClicked}>
                                <AddCircleIcon style={{ color: green[500], fontSize: 45 }} />
                            </button>
                        </div>
                    </div>
                    <Table columns={this.getColumns()} dataSource={chatIntents} />
                </Form>
            </React.Fragment>
        )
    }
}

export default ChatIntentList
